import type { ChangeEvent } from 'react';
import { useUploadWorkerQueue } from './useUploadWorkerQueue';

type Opts = {
  folderId: string;
  projectId: string;
};

export const useUploaderButton = ({ folderId, projectId }: Opts) => {
  const onFilesReceived = useUploadWorkerQueue({
    folderId,
    projectId,
    scanFileSystemEntries: false,
    uploadType: 'asset',
  });

  const onFilesSelect = async (selectedFiles: FileList) => {
    onFilesReceived({
      files: selectedFiles,
      items: null,
    });
  };

  const fileSelect = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (onFilesSelect && files) {
      onFilesSelect(files);
    }
  };

  return { fileSelect };
};
